import React from "react";
import { useYouTubeStats } from "../../hooks/useYouTubeStats";

const HSTV_COLOR = "#DC2626";
const YT_COLOR   = "#FF0000";


function YtIcon({ size = 15 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill={YT_COLOR}>
      <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
    </svg>
  );
}

function MetricCard({ label, value, loading, color, theme: t }) {
  return (
    <div style={{
      background: t.surface2, border: `1px solid ${t.border}`,
      borderRadius: 12, padding: "12px 12px 10px",
      flex: 1, minWidth: 0,
      display: "flex", flexDirection: "column", gap: 3,
    }}>
      <div style={{ fontSize: 9, color: t.textMuted, textTransform: "uppercase", letterSpacing: 1, fontWeight: 700 }}>{label}</div>
      <div style={{ fontSize: 20, fontWeight: 900, color: value != null ? color : t.textFaint, fontFamily: "Georgia, serif", lineHeight: 1.1 }}>
        {loading
          ? <span style={{ fontSize: 11, color: t.textFaint }}>…</span>
          : value != null ? value.toLocaleString() : <span style={{ fontSize: 18, color: t.textFaint }}>–</span>
        }
      </div>
    </div>
  );
}

export function HstvCard({ theme: t }) {
  const yt = useYouTubeStats();

  return (
    <div style={{
      background: t.surface,
      border: `1px solid ${yt.configured ? HSTV_COLOR + "33" : t.border}`,
      borderRadius: 16,
      padding: "16px 18px",
    }}>
      {/* Publication header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 4 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <div style={{ width: 10, height: 10, borderRadius: "50%", background: HSTV_COLOR, flexShrink: 0 }} />
          <span style={{ fontSize: 14, fontWeight: 900, color: t.text, fontFamily: "Georgia, serif" }}>HStv</span>
        </div>
        {yt.loading
          ? <span style={{ fontSize: 9, color: t.textFaint }}>Connecting…</span>
          : yt.configured
            ? <span style={{ fontSize: 9, color: "#22c55e", background: "#22c55e11", padding: "3px 8px", borderRadius: 20, border: "1px solid #22c55e33", fontWeight: 700 }}>● Live</span>
            : <span style={{ fontSize: 9, color: t.textFaint, background: t.surface2, padding: "3px 8px", borderRadius: 20, border: `1px solid ${t.border}` }}>Not Connected</span>
        }
      </div>

      {/* Subscriber count display */}
      {yt.configured && yt.subscriberCount != null && (
        <div style={{ marginBottom: 4 }}>
          <span style={{ fontSize: 22, fontWeight: 900, color: HSTV_COLOR, fontFamily: "Georgia, serif" }}>{yt.subscriberCount.toLocaleString()}</span>
          <span style={{ fontSize: 9, color: t.textMuted, textTransform: "uppercase", letterSpacing: 0.8, marginLeft: 6 }}>Subscribers</span>
        </div>
      )}

      {/* YouTube section */}
      <div style={{ borderTop: `1px solid ${t.border}`, paddingTop: 14, marginTop: 14 }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 7 }}>
            <YtIcon size={15} />
            <span style={{ fontSize: 10, fontWeight: 800, color: t.textSub, textTransform: "uppercase", letterSpacing: 1 }}>YouTube</span>
          </div>
          {yt.loading
            ? <span style={{ fontSize: 9, color: t.textFaint }}>Connecting…</span>
            : yt.configured
              ? <span style={{ fontSize: 9, color: "#22c55e", background: "#22c55e11", padding: "2px 8px", borderRadius: 20, border: "1px solid #22c55e33", fontWeight: 700 }}>● Live</span>
              : <span style={{ fontSize: 9, color: t.textFaint, background: t.surface2, padding: "2px 8px", borderRadius: 20, border: `1px solid ${t.border}` }}>Not Connected</span>
          }
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          <MetricCard label="Subscribers" value={yt.configured ? yt.subscriberCount : null} loading={yt.loading} color={YT_COLOR} theme={t} />
          <MetricCard label="Comments"    value={yt.configured ? yt.commentCount    : null} loading={yt.loading} color={YT_COLOR} theme={t} />
          <MetricCard label="Videos"      value={yt.configured ? yt.videoCount      : null} loading={yt.loading} color={YT_COLOR} theme={t} />
        </div>
      </div>

      <div style={{ marginTop: 12, fontSize: 10, color: YT_COLOR, fontWeight: 700 }}>@HStvLiveZim</div>
    </div>
  );
}
